import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { motion } from 'framer-motion';
import teamProfessional from '../../assets/features/team-professional.webp';
import automatedProcesses from '../../assets/features/automated-processes.webp';
import analyticsMetrics from '../../assets/features/analytics-metrics.webp';

const FeaturesSection: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box component="section" id="services" sx={{ paddingTop: '100px', backgroundColor: '#FFFFFF', overflow: 'hidden', width: '100%' }}>
      <Container maxWidth="xl" sx={{ maxWidth: '1280px', width: '90%' }}>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div variants={itemVariants} style={{ textAlign: 'center', marginBottom: '50px', maxWidth: '450px', margin: '0 auto 50px auto' }}>
            <Typography variant="h2" sx={{ fontSize: { xs: '26px !important', md: '36px !important' }, fontWeight: 600, color: '#070707' }}>
              Take your business to the next level
            </Typography>
          </motion.div>

          <Grid container spacing={0} sx={{ gap: '0px' }}>
            {/* Feature 1: Professional Team (50%) */}
            <Grid size={{ xs: 12, md: 5 }} sx={{ display: 'flex', pr: { md: '16px' }, pb: { xs: '16px', md: 0 } }}>
              <motion.div variants={itemVariants} style={{ width: '100%' }}>
                <Box sx={{
                  backgroundColor: '#EEEEFF',
                  padding: '35px 35px 0px 35px',
                  borderRadius: '16px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start'
                }}>
                  <Typography sx={{ fontSize: '28px', fontWeight: 600, color: '#070707', mb: '20px' }}>
                    Professional & Experienced TEAM
                  </Typography>
                  <Typography sx={{ fontSize: '16px', color: '#070707', mb: '20px', lineHeight: '1.7', fontWeight: 'normal' }}>
                    All our teammates has relevant experience in banking, payments and crypto industries.
                  </Typography>
                  <Box component="img" src={teamProfessional} alt="Team" sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    mt: '50px',
                    borderStyle: 'solid',
                    borderWidth: '1px 1px 0px 1px',
                    borderColor: '#E4EAFF',
                    borderRadius: '8px 8px 0px 0px',
                    boxShadow: '0px 16px 32px 0px rgba(0, 0, 0, 0.04)'
                  }} />
                </Box>
              </motion.div>
            </Grid>

            {/* Feature 2: Automated processes (50%) */}
            <Grid size={{ xs: 12, md: 7 }} sx={{ display: 'flex', pl: { md: '16px' }, pb: { xs: '16px', md: 0 } }}>
              <motion.div variants={itemVariants} style={{ width: '100%' }}>
                <Box sx={{
                  backgroundColor: '#EDF9F6',
                  padding: '35px 35px 0px 35px',
                  borderRadius: '16px',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-start'
                }}>
                  <Typography sx={{ fontSize: '28px', fontWeight: 600, color: '#070707', mb: '20px' }}>
                    Automated processes
                  </Typography>
                  <Typography sx={{ fontSize: '16px', color: '#070707', mb: '20px', lineHeight: '1.7', fontWeight: 'normal' }}>
                    Our core system is able to automate most of your business processes: Accounting, AML/KYC procedures, Fraud Monitoring, Blockchain Technologies, Payment Integrations with Open Banking Solutions, Payment Cards, APM's.
                  </Typography>
                  <Box component="img" src={automatedProcesses} alt="Automated" sx={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    mt: '15px',
                    borderStyle: 'solid',
                    borderWidth: '1px 1px 0px 1px',
                    borderColor: '#E4EAFF',
                    borderRadius: '8px 8px 0px 0px',
                    boxShadow: '0px 16px 32px 0px rgba(0, 0, 0, 0.04)'
                  }} />
                </Box>
              </motion.div>
            </Grid>

            {/* Feature 3: Stats/Metrics (Full Width) */}
            <Grid size={{ xs: 12, md: 12 }} sx={{ mt: '32px' }}>
              <motion.div variants={itemVariants}>
                <Box sx={{ overflow: 'hidden' }}>
                  <Grid container spacing={0}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                      <Box sx={{
                        backgroundColor: '#FAFAFA',
                        borderRadius: { xs: '16px 16px 0px 0px', md: '16px 0px 0px 16px' },
                        padding: '35px 75px 35px 35px',
                        width: '100%'
                      }}>
                        <Typography sx={{ fontSize: '28px', fontWeight: 600, color: '#070707', mb: '20px' }}>
                          Stats/Metrics
                        </Typography>
                        <Typography sx={{ fontSize: '16px', color: '#070707', mb: '20px', lineHeight: '1.7', fontWeight:'normal' }}>
                          Use intergrated BackOffice metrics to analyze the progress and weak points. Additionally, the core system is powered by Apache Superset.
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ display: 'flex' }}>
                      <Box sx={{
                        backgroundColor: '#FAFAFA',
                        borderRadius: { xs: '0px 0px 16px 16px', md: '0px 16px 16px 0px' },
                        padding: '35px 35px 0px 35px',
                        width: '100%'
                      }}>
                        <Box component="img" src={analyticsMetrics} alt="Analytics" sx={{
                          width: '100%',
                          height: 'auto',
                          objectFit: 'cover',
                          borderStyle: 'solid',
                          borderWidth: '1px 1px 0px 1px',
                          borderColor: '#E4EAFF',
                          borderRadius: '8px 8px 0px 0px',
                          boxShadow: '0px 16px 32px 0px rgba(0, 0, 0, 0.04)'
                        }} />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </motion.div>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default FeaturesSection;
